import React from "react";
import "./TechnologyPage.css";

const TechnologyPage = () => {
  return (
    <div className="techpage-root">
      <h1 className="techpage-title">Technology Page</h1>
      <p className="techpage-description">Technology Page Placeholder</p>
    </div>
  );
};

export default TechnologyPage;
